var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns is-gapless" }, [
      _c(
        "div",
        { staticClass: "column" },
        [
          _c("p", { staticClass: "title" }, [_vm._v("Revenue Totals")]),
          _c("subtitle-totals", {
            attrs: {
              labels: ["Adjust Total", "GST"],
              totals: [_vm.totalExGst, _vm.innerValue.gst],
              shows: [true, _vm.showGst],
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.innerValue.applyToInvoiceType === _vm.invoiceType.Quote ||
                _vm.innerValue.applyToInvoiceType === _vm.invoiceType.Gst,
              expression:
                "innerValue.applyToInvoiceType === invoiceType.Quote || innerValue.applyToInvoiceType === invoiceType.Gst",
            },
          ],
          staticClass: "column",
        },
        [
          !_vm.gstPaid && !_vm.readOnlyView
            ? _c("div", { staticClass: "column field is-pulled-right" }, [
                _c("p", { staticClass: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-primary tooltip is-tooltip-topright",
                      attrs: { "data-tooltip": "Add blank item" },
                      on: { click: _vm.addBlankItem },
                    },
                    [_vm._m(0)]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.innerValue.hasGstInvoice,
            expression: "innerValue.hasGstInvoice",
          },
        ],
        staticClass: "field",
      },
      [
        _c("label", { staticClass: "label" }, [
          _vm._v("Quote Invoice "),
          _c("span", [
            _vm._v(" " + _vm._s(_vm.innerValue.adjustQuoteInvoiceNo) + " "),
          ]),
        ]),
      ]
    ),
    _c("div", [
      _c(
        "table",
        { staticClass: "table is-bordered is-striped is-narrow is-fullwidth" },
        [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v("Account")]),
              _c("th", { staticClass: "has-text-right" }, [_vm._v("Amount")]),
              _c("th", { staticClass: "has-text-right" }, [
                _vm._v("New Value"),
              ]),
              _c("th", { staticClass: "has-text-right" }, [
                _vm._v("Adjust Value"),
              ]),
              _c("th", [_vm._v("Remark")]),
              !_vm.gstPaid && !_vm.readOnlyView ? _c("th") : _vm._e(),
            ]),
          ]),
          _c("tfoot", { staticClass: "no-border" }, [
            _c(
              "tr",
              {
                staticClass: "has-border-bottom-4",
                class: `debtor-adjustment-background-text-${_vm.$theme.name}`,
              },
              [
                _vm._m(1),
                _c(
                  "th",
                  { staticClass: "has-text-right", attrs: { colspan: "3" } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.innerValue.totalExGst,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
                _c("th", { attrs: { colspan: "2" } }),
              ]
            ),
            _c(
              "tr",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      !_vm.innerValue.hasGstInvoice &&
                      !_vm.innerValue.gstItem.isDeleted,
                    expression:
                      "!innerValue.hasGstInvoice && !innerValue.gstItem.isDeleted",
                  },
                ],
                class: `debtor-adjustment-background-primary-${_vm.$theme.name}`,
              },
              [
                _c("th", { staticClass: "has-text-left" }, [_vm._v("GST")]),
                _c(
                  "th",
                  { staticClass: "has-text-right", attrs: { colspan: "3" } },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.innerValue.gst,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
                _c("th", { attrs: { colspan: "2" } }),
              ]
            ),
          ]),
          _vm.gstPaid || _vm.readOnlyView
            ? _c(
                "tbody",
                [
                  _vm._l(_vm.activeItems, function (item) {
                    return _c("tr", { key: item.invoiceItemId }, [
                      _c("td", [_vm._v(_vm._s(item.glAccountName))]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatNumber(
                              item.unitPrice,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatNumber(
                              item.newValue,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatNumber(
                              item.totalExGst,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]),
                      _c("td", [_vm._v(_vm._s(item.invoiceItemDesc))]),
                    ])
                  }),
                  !_vm.innerValue.hasGstInvoice &&
                  !_vm.innerValue.gstItem.isDeleted
                    ? _c("tr", [
                        _c("td", [
                          _vm._v(_vm._s(_vm.innerValue.gstItem.glAccountName)),
                        ]),
                        _c(
                          "td",
                          { staticClass: "has-vertical-middle has-text-right" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.innerValue.gstItem.unitPrice,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          { staticClass: "has-vertical-middle has-text-right" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.innerValue.gstItem.newValue,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          { staticClass: "has-vertical-middle has-text-right" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$filters.formatNumber(
                                    _vm.innerValue.gstItem.totalExGst,
                                    _vm.$userInfo.locale
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("td", [
                          _vm._v(
                            _vm._s(_vm.innerValue.gstItem.invoiceItemDesc)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _c(
                "tbody",
                [
                  _vm._l(_vm.activeItems, function (item, index) {
                    return _c("tr", { key: item.invoiceItemId }, [
                      item.isNew &&
                      item.unitPrice === 0 &&
                      _vm.innerValue.applyToInvoiceType !=
                        _vm.invoiceType.Excess
                        ? _c(
                            "td",
                            { staticClass: "account-input" },
                            [
                              _vm.glAccountListComboFilter &&
                              _vm.selectedItemAccounts.length > 0
                                ? _c(
                                    "multiselect",
                                    {
                                      attrs: {
                                        options: _vm.glAccountListComboFilter,
                                        placeholder: "Select account",
                                        label: "displayName",
                                        "track-by": "accountNo",
                                        "deselect-label":
                                          "Can't remove this value",
                                        "show-labels": false,
                                        "allow-empty": false,
                                      },
                                      model: {
                                        value: _vm.selectedItemAccounts[index],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selectedItemAccounts,
                                            index,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "selectedItemAccounts[index]",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "has-text-danger",
                                          attrs: { slot: "noResult" },
                                          slot: "noResult",
                                        },
                                        [_vm._v("G/L account not found.")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c("td", [_vm._v(_vm._s(item.glAccountName))]),
                      _c(
                        "td",
                        { staticClass: "has-vertical-middle has-text-right" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatNumber(
                                item.unitPrice,
                                _vm.$userInfo.locale
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "td",
                        { staticClass: "has-text-right money-input" },
                        [
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: { minus: true, precision: 2 },
                            on: {
                              "value-changed": function ($event) {
                                return _vm.updateNewValue(item)
                              },
                            },
                            model: {
                              value: item.newValue,
                              callback: function ($$v) {
                                _vm.$set(item, "newValue", _vm._n($$v))
                              },
                              expression: "item.newValue",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticClass: "has-text-right money-input" },
                        [
                          _c("vue-numeric", {
                            staticClass: "input has-text-right",
                            attrs: { minus: true, precision: 2 },
                            on: {
                              "value-changed": function ($event) {
                                return _vm.updateAdjustValue(item)
                              },
                            },
                            model: {
                              value: item.totalExGst,
                              callback: function ($$v) {
                                _vm.$set(item, "totalExGst", _vm._n($$v))
                              },
                              expression: "item.totalExGst",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: item.invoiceItemDesc,
                              expression: "item.invoiceItemDesc",
                            },
                          ],
                          staticClass: "input",
                          attrs: { type: "text", placeholder: "Remark" },
                          domProps: { value: item.invoiceItemDesc },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                item,
                                "invoiceItemDesc",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      item.unitPrice === 0
                        ? _c(
                            "td",
                            {
                              staticClass:
                                "has-vertical-middle has-text-centered is-content-width",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "button is-danger is-small is-inverted",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteItem(item, index)
                                    },
                                  },
                                },
                                [_vm._m(2, true)]
                              ),
                            ]
                          )
                        : _c("td"),
                    ])
                  }),
                  !_vm.innerValue.hasGstInvoice &&
                  !_vm.innerValue.gstItem.isDeleted
                    ? _c("tr", [
                        _c("td", [
                          _vm._v(_vm._s(_vm.innerValue.gstItem.glAccountName)),
                        ]),
                        _c(
                          "td",
                          { staticClass: "has-vertical-middle has-text-right" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  _vm.innerValue.gstItem.unitPrice,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]
                        ),
                        _vm.editGst
                          ? _c(
                              "td",
                              { staticClass: "has-text-right money-input" },
                              [
                                _c("vue-numeric", {
                                  staticClass: "input has-text-right",
                                  attrs: { minus: true, precision: 2 },
                                  on: {
                                    "value-changed": function ($event) {
                                      return _vm.updateNewValue(
                                        _vm.innerValue.gstItem
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.innerValue.gstItem.newValue,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.innerValue.gstItem,
                                        "newValue",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "innerValue.gstItem.newValue",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-right",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        _vm.innerValue.gstItem.newValue,
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                        _vm.editGst
                          ? _c(
                              "td",
                              { staticClass: "has-text-right money-input" },
                              [
                                _c("vue-numeric", {
                                  staticClass: "input has-text-right",
                                  attrs: { minus: true, precision: 2 },
                                  on: {
                                    "value-changed": function ($event) {
                                      return _vm.updateAdjustValue(
                                        _vm.innerValue.gstItem
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.innerValue.gstItem.totalExGst,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.innerValue.gstItem,
                                        "totalExGst",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "innerValue.gstItem.totalExGst",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "td",
                              {
                                staticClass:
                                  "has-vertical-middle has-text-right",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$filters.formatNumber(
                                        _vm.innerValue.gstItem.totalExGst,
                                        _vm.$userInfo.locale
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.innerValue.gstItem.invoiceItemDesc,
                                expression:
                                  "innerValue.gstItem.invoiceItemDesc",
                              },
                            ],
                            staticClass: "input",
                            attrs: { type: "text", placeholder: "Remark" },
                            domProps: {
                              value: _vm.innerValue.gstItem.invoiceItemDesc,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.innerValue.gstItem,
                                  "invoiceItemDesc",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c("td"),
                      ])
                    : _vm._e(),
                ],
                2
              ),
        ]
      ),
    ]),
    _c("div", { staticClass: "column" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-shape-square-plus" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", { staticClass: "has-text-left" }, [
      _vm._v("Total "),
      _c("span", { staticClass: "subtext" }, [_vm._v("(Ex GST)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-medium" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }